import { Box, SpaceBetween } from "@amzn/awsui-components-console";
import React from "react";

const UserShareAccessHelpPanel: React.FC = () => (
  <SpaceBetween size="m">
    <Box>
      <h3>User Share Access</h3>
      <p>
        Control which users can create public share links for clips. Sharing is
        enabled for every user by default.
      </p>
    </Box>
    <Box>
      <h3>How it works</h3>
      <ul>
        <li>
          Disable a user to revoke their ability to create new public share
          links.
        </li>
        <li>Re-enable a user to restore that access.</li>
        <li>
          Changing access does not delete links a user has already created.
        </li>
      </ul>
    </Box>
  </SpaceBetween>
);

export default UserShareAccessHelpPanel;
